import React from 'react';
import { withRouter } from 'react-router-dom';
import LargePaper from '../../components/Layout/LargePaper';
import stylesDefault from '../../constants/stylesDefault';
import EditSiteForm from '../../components/Site/EditSiteForm';
import withAuthorization from '../../hoc/withAuthorization';

const EditSitePage = props =>
  <LargePaper>
    <h1 style={stylesDefault.title}>Modification d'un site</h1>
    <EditSiteForm history={props.history} match={props.match}/>
  </LargePaper>;

const authCondition = authUser => !!authUser;

export default withAuthorization(authCondition)(withRouter(EditSitePage));



// WEBPACK FOOTER //
// ./src/containers/SitesPage/EditSitePage.jsx